module.exports = __webpack_public_path__ + "img/17e7a8acb8d6e365de0c66b048dfe0ac.png";